import Swiper from "swiper";
import { Navigation } from "swiper/modules";

const SCROLLED_FAR_CLASS = "is-scrolled-far";
const SCROLLED_FAR_AFTER = 2;

export const storesSlider = () => {
    const $stores = document.querySelector(".section-stores__items");
    const $storesRoot = $stores.closest(".section-stores");

    const swiper = new Swiper($stores, {
        slidesPerView: 4.4,
        spaceBetween: 16,
        modules: [Navigation],
        navigation: {
            prevEl: $stores.querySelector(".slider-controls__arrow--prev"),
            nextEl: $stores.querySelector(".slider-controls__arrow--next"),
        },
        on: {
            slideChange(swiper) {
                $storesRoot.classList.toggle(SCROLLED_FAR_CLASS, swiper.activeIndex > SCROLLED_FAR_AFTER);
            }
        },
        breakpoints: {
            0: {
                slidesPerView: 1.3
            },
            481: {
                slidesPerView: 2.4
            },
            641: {
                slidesPerView: 3.4
            },
            961: {
                slidesPerView: 4.4
            }
        }
    });
};